/* iter-43 — Demo Upgrade Modal.
 * Pops automatically after 3 demo-lock interactions OR 10 minutes of demo
 * use, whichever comes first. Also openable manually from anywhere via
 * `useDemo().openUpgrade()`.
 */
import React from 'react';
import { Sparkles, Check, X, ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useAuth } from '@/lib/auth_context';

const PERKS = [
  'Real AI generations (Claude, GPT, or Gemini — your pick)',
  'Stream chapters, revisions, continuations',
  'Stripe-secured token top-ups',
  'Paid editing, publishing & cover art',
  'Bookstore listing & royalties tracking',
];

export default function DemoUpgradeModal({ open, onClose, source = 'auto' }) {
  const { login } = useAuth();
  if (!open) return null;
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 p-4"
      onClick={(e) => { if (e.target === e.currentTarget) onClose?.(); }}
      data-testid="demo-upgrade-modal"
    >
      <div className="w-full max-w-md overflow-hidden rounded-xl border border-border bg-card shadow-2xl">
        <div className="relative border-b border-border bg-gradient-to-br from-primary/15 via-card to-card px-5 py-4">
          <button
            onClick={onClose}
            className="absolute right-3 top-3 text-muted-foreground hover:text-foreground"
            data-testid="demo-upgrade-close"
          >
            <X className="h-4 w-4" />
          </button>
          <div className="flex items-center gap-2 text-primary">
            <Sparkles className="h-4 w-4" />
            <span className="text-[10.5px] uppercase tracking-[0.18em]">
              {source === 'lock' ? 'Locked in demo mode' : "We hope you're enjoying the preview"}
            </span>
          </div>
          <h2 className="mt-1 text-[18px] font-semibold tracking-tight">Ready for the real thing?</h2>
          <p className="mt-1 text-[12.5px] text-muted-foreground leading-relaxed">
            Sign up free in 10 seconds to unlock everything in The Loom V2.38_f55. We'll keep your demo notes.
          </p>
        </div>

        <ul className="space-y-1.5 px-5 py-4 text-[12.5px]">
          {PERKS.map((p) => (
            <li key={p} className="flex items-center gap-2">
              <Check className="h-3.5 w-3.5 shrink-0 text-success" />
              <span>{p}</span>
            </li>
          ))}
        </ul>

        <div className="flex items-center justify-between gap-2 border-t border-border bg-panel-header/40 px-5 py-3">
          <Button variant="ghost" size="sm" onClick={onClose} data-testid="demo-upgrade-later">
            Keep exploring
          </Button>
          <Button size="sm" className="gap-1.5" onClick={login} data-testid="demo-upgrade-cta">
            Start free trial <ArrowRight className="h-3.5 w-3.5" />
          </Button>
        </div>
      </div>
    </div>
  );
}
